var Backbone = require('backbone');
var _ = require('lodash');
var jQuery = require('jquery');
var template = require('../templates/auth.ejs');

// h5validate plugin
require( 'h5validate' );
var $ = jQuery;

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-auth',
    events: {
        'click .facebook': 'fbSignin',
        //, 'click .google' : 'googleSignin'
        'click .email': 'email',
        'click .terms': 'terms',
        'click .faux-box': 'toggleCheck',
        'click .label': 'toggleCheck',
        'click #submitEmailAuth': 'emailSignin',
        'change .email-address': 'activeSubmit',
        'keydown .email-address': 'activeSubmit'
    },
    /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render', 'activeSubmit');
        this.cms = options.cms;
        this.auth = options.auth;
        this.facebook = options.facebook;
        this.router = options.router;
    },
    /**
   *
   */
    fbSignin: function(e) {
        e.preventDefault();
        console.log('fbSignin', e);

        if( jQuery.fn.h5Validate.call( this.$( '.optin-form' ), 'allValid' ) ){
            this.facebook.isConnected(_.bind(this.fbSignInResponse, this));
            this.router.loading('facebook');
        }
    },
    /**
   *
   */
    fbSignInResponse: function(response) {
        console.log('fbSignInResponse', response);
        if (response) {
            this.storeOptins();
            this.router.closeCurrentModal();
            this.auth.signInSuccess('facebook');
            var evt = {
                target: this,
                name: 'eventLoginFacebook',
                origEvent: response
            };
            this.trigger('trackEvent',evt);
        } else {
            // re-render the auth view
            this.router.auth();
        }
    },
    /**
   *
   */
    emailSignin: function(e) {
        e.preventDefault();

        var validOptins = jQuery.fn.h5Validate.call( this.$('.optin-form'), 'allValid' );
        var validEmail = jQuery.fn.h5Validate.call( this.$('#emailAuthForm'), 'allValid' );

        if (validEmail && validOptins) {
            var email = this.$('#email').val();
            this.storeOptins();
            this.router.closeCurrentModal();
            this.auth.signInSuccess('email', email);
            var evt = {
                target: this,
                name: 'eventLoginEmail',
                origEvent: e
            };
            this.trigger('trackEvent',evt);
        }
    },
    /**
   *
   */
    googleSignin: function(e) {
        console.log('e:', e);
        e.preventDefault();
    //this.controller.Models.GoogleAuth.login();
    },
    /**
   *
   */
    email: function(e) {
        e.preventDefault();

        $('div.email-vote').toggleClass('hidden');
        $('div.facebook').toggleClass('eliminated');
        //$("div.google").toggleClass("eliminated");

        //Animate scrolling down modal to allow users to see email form
        $('div.modal').animate({
            scrollTop: $('#emailAuthForm').offset().top
        },
        'slow');
    },
    /**
   *
   */
    terms: function(e) {
        e.preventDefault();
        console.log('show terms and conditions');
    },
    /**
   *
   */
    render: function() {
        var that = this;
        this.createModel();
        that.$el.html(template({
            text: this.model.text,
            terms: this.cms.get('text').views_page_footer
        }));
        console.log('auth view[model]', this.model);

        // this.$('.optin-form').h5validate();
        // this.$('#emailAuthForm').h5validate();

        jQuery.fn.h5Validate.call( this.$( '.optin-form' ) );
        jQuery.fn.h5Validate.call( this.$( '#emailAuthForm' ) );

        _.each(this.$('.checkbox-parent'), _.bind(function(el) {
            var $faux = $(el).find('.faux-box');
            var $checkbox = $(el).find('[type=\'checkbox\']');
            if ($checkbox.is(':checked')) {
                $faux.addClass('checked');
                $checkbox.prop('checked', true);
            }
        }, this));

        return this;
    },
    toggleCheck: function(e) {
        e.preventDefault();
        var $parent = $(e.currentTarget).parent();
        var $checkmark = $parent.find('.check-mark');
        var $checkbox = $parent.find('[type=\'checkbox\']');

        if ($checkbox.is(':checked')) {
            $checkbox.prop('checked', false);
            $checkmark.css('display', 'none');
        } else {
            $checkbox.prop('checked', true);
            $checkmark.css('display', '');
        }
    },
    /**
   *
   */
    createModel: function() {
        this.model = {
            'text': this.cms.get('text')['views_login']
        };

        console.log(this.model);
        console.log('%c Model for login view', 'background-color: blue;');
    },
    /**
   *
   */
    activeSubmit: _.debounce(function(e) {
        var valid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( e.target.value );
        this.$('#submitEmailAuth').attr('disabled', !valid);
        valid ? this.$('#submitEmailAuth').removeClass('eliminated') : this.$('#submitEmailAuth').addClass('eliminated');
    },50),
    /**
   *
   */
    storeOptins: function() {
    // they are prefixed with '-optin'
        $.each(this.$el.find('form [type=checkbox]'), _.bind(function(i, el) {
            var evt = {
                target: this,
                name: 'eventClickOptin',
                origEvent: 'optin-' + $(el).attr('name')
            };
            this.trigger('trackEvent',evt);
            localStorage['optin-' + $(el).attr('name')] = ($(el).prop('checked') ? 'true' : 'false');
        }, this));

    },

    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/auth.js
// module id = 256
// module chunks = 0